import React, { useEffect } from 'react';
import './landing.css';
import { BACKDROP_PARAMS, useSceneLayout } from './layout';
import Backdrop from './Backdrop';
import LandingNav from './LandingNav';
import CosmosHero from './CosmosHero';
import LandingSections from './LandingSections';
import WarehouseLandingSections from './WarehouseLandingSections';
import Assistant from './Assistant';

const FONT_HREF = 'https://fonts.googleapis.com/css2?family=Unbounded:wght@300;400;500&display=swap';


// Cosmos landing page. Only mounted at "/" when the bundle is built with
// REACT_APP_LANDING=cosmos (the /site1 preview build). It brings its own
// overlay nav; the standard site footer still follows it.
const Landing: React.FC = () => {
  const layout = useSceneLayout();
  const backdrop = BACKDROP_PARAMS[layout];

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('lp-root');
    const previousTitle = document.title;
    document.title = 'TrueLog | Move ICT anywhere on Earth';

    // the /site3 build sets its headings in the main site's Sora (index.css); only the cosmos/hardware variants need Unbounded
    if (process.env.REACT_APP_LANDING !== 'warehouse' && !document.querySelector('link[data-lp-font]')) {
      const preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://fonts.gstatic.com';
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = FONT_HREF;
      link.setAttribute('data-lp-font', '1');
      document.head.appendChild(link);
    }

    return () => {
      root.classList.remove('lp-root');
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="lp">
      <Backdrop sun={backdrop.sun} ember={backdrop.ember} />
      {process.env.REACT_APP_LANDING !== 'warehouse' && <LandingNav />}
      <CosmosHero />
      {process.env.REACT_APP_LANDING === 'warehouse' ? <WarehouseLandingSections /> : <LandingSections />}
      <Assistant />
    </div>
  );
};

export default Landing;
